import React from 'react';
import './Toast.less';
declare var window :any
export interface ToastInfo {
  id: string;
  text: string;
  mask: boolean;
  duration: number;
}

export interface ToastPropType {
  info: ToastInfo;
  onClose: (id, type) => void;
  prefixCls?: string;
}

class TeXiao extends React.Component<ToastPropType> {
  static defaultProps = {
    prefixCls: 'toast'
  }

  time: any;

  componentDidMount() {
    const {info, onClose} = this.props;
    clearTimeout(this.time);
    this.time = setTimeout(() => {
      if (onClose) {
        onClose(info.id, 'TeXiao');
      }
    }, info.duration);
  }

  componentWillUnmount() {
    clearTimeout(this.time);
  }

  render() {
    const {info, prefixCls} = this.props;
    window.myConsole(info)
    let style:any = {};
    if (!info.mask) {
      style.pointerEvents = 'none';
    }

    return <div className={prefixCls} style={style}>
      <div className={`${prefixCls}-img`}>
       {/*  <img src={require("../../images/like.svg")} alt=""/> */}
      </div>
    </div>
  }
}

export default TeXiao;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/notice/TeXiao.tsx